import React, { useEffect, useState } from "react";
import styled from "styled-components";
import IconClose from "../images/close.svg";

const AlertPanel = styled.div`
  text-align: center;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-160px, -130px);
  z-index: 100;
  width: 320px;
  height: 200px;
  box-shadow: 5px 5px 0 #4a4a4a;
  border: 1px solid #000;

  h3 {
    margin: 0;
    padding: 0;
    font-size: 18px;
    line-height: 28px;
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  button {
    background: none;
    border: none;
    height: 70px;
    width: 100%;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    img {
      display: block;
    }
  }
`;

const Alert = ({ lang }) => {
  const [visible, setVisible] = useState(false);
  const [didClose, setDidClose] = useState(false);

  useEffect(() => {
    let angle;
    try {
      angle = window.screen.orientation.angle;
    } catch (error) {
      angle = window.orientation;
    }

    if (angle === 90 || angle === 270 || angle === -90) {
      if (!didClose) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    } else {
      setVisible(false);
    }

    window.addEventListener("orientationchange", function (e) {
      try {
        angle = window.screen.orientation.angle;
      } catch (error) {
        angle = window.orientation;
      }
      if (angle === 90 || angle === 270 || angle === -90) {
        if (!didClose) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      } else {
        setVisible(false);
      }
    });
  }, [visible, didClose]);

  const handleClick = () => {
    setDidClose(true);
    setVisible(false);
  };

  return (
    visible && (
      <AlertPanel>
        {lang === 0 ? (
          <h3>
            Viewing in <br />
            portrait mode<br />
            is recommended
          </h3>
        ) : (
          <h3>
            縦画面でご覧ください
          </h3>
        )}
        <button onClick={handleClick}>
          <img src={IconClose} alt="Close Icon" />
          Close
        </button>
      </AlertPanel>
    )
  );
};

export default Alert;
